import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { colors, media, pxToRem } from '@vfit/shared/themes';

export const OfferMapColumn = styled.div<{ embedded?: boolean }>`
  width: 100%;
  max-width: 100%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-self: stretch;
`;

export const OfferMapContainer = styled.div<{ embedded?: boolean }>`
  position: relative;
  overflow: hidden;
  background: ${colors.$ffffff};

  * {
    margin: 0;
  }

  .gmnoprint,
  .gm-style-cc {
    display: none !important;
  }

  ${({ embedded }) =>
    embedded
      ? css`
          display: flex;
          width: 100%;
          max-width: 100%;
          height: ${pxToRem(140)};
          flex-direction: column;
          align-items: flex-start;
          gap: ${pxToRem(10)};
          border: none;
          border-radius: 0;
          box-sizing: border-box;
        `
      : css`
          width: 100%;
          max-width: 100%;
          border: 1px solid ${colors.$bebebe};
          border-radius: ${pxToRem(20)};
        `}
`;

export const ManageMapHeight = styled.div<{ embedded?: boolean }>`
  position: relative;
  overflow: hidden;

  > div {
    width: 100% !important;
    height: 100% !important;
  }

  ${({ embedded }) =>
    embedded
      ? css`
          flex: 1 1 auto;
          align-self: stretch;
          width: 100%;
          min-height: 0;
        `
      : css`
          width: 100%;
          max-width: 100%;
          height: ${pxToRem(160)};

          ${media.tablet`
            height: ${pxToRem(200)};
          `}

          ${media.largeDesktop`
            height: ${pxToRem(320)};
          `}
        `}
`;

export const MapLoadingOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 1;
`;
